import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './components/elementsui/CartContext';

import Navbar from './components/Header/Navbar';
import CustomFooter from './components/Header/CustomFooter';

import HomePage from './components/pages/HomePage';
import FruitsAndVegetables from './components/pages/FruitsAndVegetables';
import TermsPolicy from './components/pages/TermsPolicy';
import CartDesign from './components/pages/CartPage';
import ContactUsPage from './components/pages/ContactUsPage';
import LoginPage from './components/pages/LoginPage';
import OrderPlacementPage from './components/pages/OrderPlacementPage';
import OrderConfirmation from './components/pages/OrderConfirmation';
import MyOrdersPage from './components/pages/MyOrdersPage';
import OrderTracking from './components/pages/OrderTrackingPage';
import ProductDetailPage from './components/pages/ProductDetailPage';
import CategoryDetail from './components/pages/CategoryDetail';
import UserAccountPage from './components/pages/UserAccountPage';
import GoogleCallbackHandler from './components/User/GoogleCallbackHandler';
import GoogleAddressPrompt from './components/pages/GoogleAddressPrompt';
import ComboOffers from './components/pages/ComboOffers';

function App() {
  const location = useLocation(); // ✅ Tracks route changes

  return (
    <CartProvider>
      <Navbar />

      <main style={{ minHeight: '80vh' }}>
        {/* ✅ Force remounting on route change */}
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<HomePage />} />
          <Route path="/category" element={<ComboOffers />} />
          <Route path="/account" element={<UserAccountPage />} />
          <Route path="/fruits-vegetables" element={<FruitsAndVegetables />} />
          <Route path="/policy" element={<TermsPolicy />} />
          <Route path="/cart" element={<CartDesign />} />
          <Route path="/categories/:category" element={<CategoryDetail />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/google/success" element={<GoogleCallbackHandler />} />
          <Route path="/auth/google/address" element={<GoogleAddressPrompt />} />

          <Route path="/order" element={<OrderPlacementPage />} />
          <Route path="/order-confirmation" element={<OrderConfirmation />} />
          <Route path="/my-orders" element={<MyOrdersPage />} />
          <Route path="/track-order/:orderId" element={<OrderTracking />} />
          <Route path="/product/:id" element={<ProductDetailPage />} />
        </Routes>
      </main>

      <CustomFooter />
    </CartProvider>
  );
}

export default App;
